<template>
  <v-dialog v-model="dialogComputed" :persistent="!isInquiry" :width="getWidth()" scrollable>
    <v-card v-if="dialogComputed">
      <v-card-title class="primary white--text py-2">
        {{ $t('ELE0284') }}
        <v-spacer />
        <Btn icon="mdi-close" @click="close" depressed iconProp color="white" />
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-card outlined>
                <v-data-table
                  :headers="headers"
                  :items="editCharacItem.bodies"
                  disable-pagination
                  hide-default-header
                  hide-default-footer
                  disable-sort
                  height="360px"
                  dense
                >
                  <template #header>
                    <th
                      v-for="item in headers"
                      v-bind:key="item.value"
                      class="v-data-table__divider data-table-bottom-line"
                    >
                      {{ item.text }}
                      <div v-if="item.isFiltering" class="d-flex flex-row justify-space-around">
                        <v-checkbox
                          v-if="headerCheckboxStatus[item.value]"
                          :label="enumInspGradeCd.A"
                          v-model="headerCheckboxStatus[item.value][enumInspGradeCd.A]"
                          :ripple="false"
                          color="primary"
                          class="px-0 py-0"
                          dense
                          hide-details
                          :disabled="isInquiry ? true : isReadOnly(item.value)"
                          @change="onClickSelectAll(enumInspGradeCd.A, item.value)"
                        />
                        <v-checkbox
                          v-if="headerCheckboxStatus[item.value]"
                          :label="enumInspGradeCd.B"
                          v-model="headerCheckboxStatus[item.value][enumInspGradeCd.B]"
                          :ripple="false"
                          color="primary"
                          class="px-0 py-0"
                          dense
                          hide-details
                          :disabled="isInquiry ? true : isReadOnly(item.value)"
                          @change="onClickSelectAll(enumInspGradeCd.B, item.value)"
                        />
                      </div>
                    </th>
                  </template>
                  <template v-for="filteringCd in selectInspFiltering" v-slot:[`item.${filteringCd}`]="{ item }">
                    <div :key="item[`${filteringCd}`]">
                      <v-simple-checkbox
                        label=""
                        v-model="item[`${filteringCd}`]"
                        :ripple="false"
                        color="primary"
                        :disabled="isInquiry ? true : isReadOnly(filteringCd)"
                        @input="onChangeItem(filteringCd)"
                      />
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-divider />
        <v-row>
          <v-col class="mt-2 d-flex justify-end">
            <Btn v-if="isInquiry" :label="$t('ELE0020')" @click="close" />
            <Btn v-else :label="$t('ELE0105')" @click="onClickSet" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { InspGradeCd } from '@/enum'
import Btn from '@/components/atoms/base/button/Btn'
import BtnClose from '@/components/atoms/button/BtnClose'

export default {
  name: 'EditCharacteristicDialog',

  components: {
    Btn,
    BtnClose,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    editCharacItem: {
      type: Object,
      required: true,
    },
    selectInspFiltering: {
      type: Array,
      required: true,
      default: () => [],
    },
    isInquiry: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  watch: {
    dialog() {
      if (this.dialog) {
        this.initSelectAll()
      }
    },
  },

  computed: {
    enumInspGradeCd: () => InspGradeCd,
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
    editCharacItemComputed: {
      get() {
        return this.editCharacItem
      },
      set(value) {
        this.$emit('update:editCharacItem', value)
      },
    },
    headers: {
      get() {
        let result = [
          { text: this.$t('ELE0091'), value: 'charac', divider: true, width: '10%', isFiltering: false },
          { text: this.$t('ELE0092'), value: 'point', divider: true, width: '10%', isFiltering: false },
          { text: this.$t('ELE0094'), value: 'grade', divider: true, width: '10%', isFiltering: false },
        ]
        this.editCharacItem.filteringHeader
          .filter((item) => this.selectInspFiltering.includes(item.inspFilteringCd))
          .forEach((element) => {
            result.push({
              text: element.inspFilteringName,
              value: element.inspFilteringCd,
              divider: true,
              align: 'center',
              isFiltering: true,
            })
          })
        return result
      },
    },
  },

  data() {
    return {
      headerCheckboxStatus: {},
    }
  },

  methods: {
    initSelectAll() {
      this.selectInspFiltering.forEach((filteringCd) => this.setSelectAllValue(filteringCd))
    },
    close() {
      this.dialogComputed = false
    },
    getWidth() {
      return 300 + this.selectInspFiltering.length * 100
    },
    isReadOnly(filteringCd) {
      let result = false
      const headerItem = this.editCharacItem.filteringHeader.find((item) => item.inspFilteringCd === filteringCd)
      result = headerItem.isReadOnly
      return result
    },
    onClickSet() {
      this.$emit('setItems')
      this.close()
    },
    onClickSelectAll(inspGradeCd, filteringCd) {
      // Filtering, Gradeで絞った特性毎のis_inspを変更
      let inspFilterings = this.getInspFilteringList(inspGradeCd)
      if (inspFilterings.some((e) => e[filteringCd] == false)) {
        inspFilterings.forEach((e) => {
          e[filteringCd] = true
        })
      } else {
        inspFilterings.forEach((e) => {
          e[filteringCd] = false
        })
      }
    },
    getInspFilteringList(inspGradeCd) {
      // inspGradeCdが同じ特性の一覧を取得
      return this.editCharacItemComputed.bodies.filter((e) => e.grade == inspGradeCd)
    },
    onChangeItem(filteringCd) {
      // Filtering, Gradeで他のis_inspを見る必要があるため、初期表示と同じ判定をする
      this.setSelectAllValue(filteringCd)
    },
    setSelectAllValue(filteringCd) {
      // 全件選択チェックボックスを判定してセット
      this.$set(this.headerCheckboxStatus, filteringCd, {
        [InspGradeCd.A]: this.isAllTrue(this.getInspFilteringList(InspGradeCd.A).map((e) => e[filteringCd])),
        [InspGradeCd.B]: this.isAllTrue(this.getInspFilteringList(InspGradeCd.B).map((e) => e[filteringCd])),
      })
    },
    isAllTrue(l) {
      // 配列が空、1件でもfalseが存在すればfalse
      // すべてtrueのみtrue
      if (l.length === 0) return false
      return !l.includes(false)
    },
  },
  async mounted() {
    this.initSelectAll()
  },
}
</script>

<style scoped>
.data-table-bottom-line {
  border-bottom: solid 1px #000000 !important;
  vertical-align: top;
}
</style>
